<template>
    <div class="layout"></div>
</template>

<style scoped>
    .layout{
        background: url('~@/assets/images/content/layout-amige.jpg') no-repeat center top;
        height: 4676px;
    }
</style>